export default "__VITE_ASSET__BNGMot3J__"